<template>
  <div>
    <HeaderMain :menuType="currentMenuType"></HeaderMain>
    <div class="index-container">
      <div class="index-box-01">
        <div class="index-box-01-main">
          <div class="index-box-01-box">
            <div class="index-box-01-title">
              <i class="right"
                ><img src="../assets/fastcolumn-title-arr.png"
              /></i>
              <span
                ><h1>集团简介</h1>
                <h2>Management team</h2></span
              >
            </div>
          </div>
          <div class="index-box-01-box">
            <div class="index-box-01-img1">
              <img src="../assets/index-box-01-img1.jpg" />
              <p>
                三个苹果引进国外最先进的生产设备，所产青汁产品畅销美国、加拿大、欧洲、亚洲等二十多个国家和地区。
                是可口可乐、百事可乐、柯林斯等世界顶级企业的果汁原料供
                应商，产品生产通过192多道物理压榨、检测、
                分离工艺，拒绝任何添加剂，保证产品绝对纯正天然。
              </p>
            </div>
          </div>
          <!-- <div class="index-box-01-box">
            <a href="http://www.tcmedical.com.cn/index/index" target="_blank">
              <div class="index-box-01-title index-box-title-blue">
                <span><h1>通策医疗</h1></span>
              </div>
            </a>
          </div>
          <div class="index-box-01-box">
            <div class="index-box-01-img2">
              <img src="../assets/index-box-01-img2.jpg" />
            </div>
          </div>
          <div class="index-box-01-box">
            <div class="index-box-01-img3">
              <img src="../assets/index-box-01-img3.jpg" />
            </div>
          </div> -->
          <div class="clear"></div>
        </div>
      </div>

      <!-- <div class="index-box-02">
      <div class="index-box-02-main">
        <div class="index-box-02-box">
          <div class="index-box-02-title"><i class="right"><img src="../assets/fastcolumn-title-arr.png"></i>
            <span><h1>口腔事业部</h1><h2>Management team</h2></span>     
          </div>
        </div>
        <div class="index-box-02-box">
          <div class="index-box-02-img1">
            <img src="../assets/index-box-02-img1.jpg">
          </div>
        </div>
        <div class="index-box-02-box-line2">
          <div class="index-box-02-box">
            <a href="javascript:alert('网站建设中...')" target="_blank">
            <div class="index-box-02-title index-box-title-blue">              
              <span><div class="index-box-02-img2"><img src="../assets/cjkqyy-logo.png"></div><h1>存济口腔医院</h1><h2>Management team</h2></span>     
            </div>
            </a>
            <div class="index-box-02-title index-box-title-white">              
              <div class="index-box-02-img3"><img src="../assets/index-box-02-img3.jpg"></div>  
            </div>
          </div>
          <div class="index-box-02-box">
            <div class="index-box-02-img4">
              <img src="../assets/index-box-02-img4.jpg"> 
            </div>
          </div>  
          <div class="index-box-02-box">
            <div>
              <div class="index-box-02-img5">
                <img src="../assets/index-box-02-img5.jpg"> 
              </div>
            </div>
            <div style="margin-top:6px;">
              <div class="left">
                <div class="index-box-02-img6">
                  <img src="../assets/index-box-02-img6.jpg"> 
                </div>
              </div>  
              <div class="right">
                <div class="index-box-02-img7">
                  <img src="../assets/index-box-02-img7.jpg"> 
                </div>
              </div>      
            </div>
            
          </div>          
        </div>

        <div class="clear"></div>
      </div>
    </div>  

    <div class="index-box-03">
      <div class="index-box-03-main">
        <div class="index-box-03-box">
          <div class="index-box-03-title"><i class="right"><img src="../assets/fastcolumn-title-arr.png"></i>
            <span><h1>妇幼事业部</h1><h2>Management team</h2></span>     
          </div>
        </div>
        <div class="index-box-03-box">
          <div class="index-box-03-img1">
            <a href="http://www.bourn-hall.com.cn" target="_blank"><img src="../assets/index-box-03-img1.jpg"></a>            
          </div>
        </div>
        <div class="index-box-03-box">
          <a href="http://www.bourn-hall.com.cn" target="_blank">
          <div class="index-box-03-img2">
            <img src="../assets/index-box-03-img2.jpg"> 
            <p>引入国外全科医生理念，汇聚国内外一流医疗资源，聚焦妇科，产科等优势专科领域，满足高端人群对高质量诊疗服务的需求。</p>
          </div>
          </a>  
        </div>
        <div class="index-box-03-box-line2">
          <div class="index-box-03-box">
            <div class="index-box-03-title">              
              <div class="index-box-03-img3"><img src="../assets/index-box-03-img3.jpg"></div>  
            </div>
            <div class="index-box-03-title index-box-title-gray">              
              <div class="index-box-03-img4"><img src="../assets/index-box-03-img4.jpg"></div>  
            </div>
          </div>
          <div class="index-box-03-box">
            <div class="index-box-03-img5">
              <img src="../assets/index-box-03-img5.jpg">
              <p>Trust your instincts<br/>You’ll know when you’ve found somewhere that feels right</p>
            </div>
          </div>
          <div class="index-box-03-box">
            <div class="index-box-03-title">              
              <div class="index-box-03-img6"><img src="../assets/index-box-03-img6.jpg"></div>  
            </div>
            <div class="index-box-03-title index-box-title-gray">              
              <div class="index-box-03-img7"><img src="../assets/index-box-03-img7.jpg"></div>  
            </div>
          </div>
        </div>

        <div class="clear"></div>
      </div>
    </div>  


    <div class="index-box-04">
      <div class="index-box-04-main">
        <div class="index-box-04-box">
          <div class="index-box-04-title"><i class="right"><img src="../assets/fastcolumn-title-arr.png"></i>
            <span><h1>眼科事业部</h1><h2>Management team</h2></span>     
          </div>
        </div>
        <div class="index-box-04-box">
          <div class="index-box-04-img1">
            <img src="../assets/index-box-04-img1.jpg">
          </div>
        </div>
        <div class="index-box-04-box-line2">          
          <div class="index-box-04-box">
            <div class="index-box-04-img2">
              <img src="../assets/index-box-04-img2.jpg"> 
            </div>
          </div>  
          <div class="index-box-04-box">                  
            <div class="index-box-04-img3">
              <img src="../assets/index-box-04-img3.jpg"> 
            </div>
          </div>  
          <div class="index-box-04-box">                  
            <div class="index-box-04-img4">
              <img src="../assets/index-box-04-img4.jpg"> 
            </div>
            <div class="index-box-04-img5">
              <img src="../assets/index-box-04-img5.jpg"> 
            </div>
          </div>          
        </div>

        <div class="clear"></div>
      </div>
    </div>  

    <div class="index-box-05">
      <div class="index-box-05-main">
        <div class="index-box-05-box">
          <div class="index-box-05-title"><i class="right"><img src="../assets/fastcolumn-title-arr.png"></i>
            <span><h1>信息事业</h1><h2>Management team</h2></span>     
          </div>
        </div>
        <div class="index-box-05-box">
          <div class="index-box-05-img1">
            <a href="http://www.eetop.com/index/home" target="_blank"><img src="../assets/index-box-05-img1.jpg"></a>            
          </div>
        </div>
        <div class="index-box-05-box">
          <a href="http://www.eetop.com/index/home" target="_blank">
          <div class="index-box-05-img2">
            <img src="../assets/index-box-05-img2.jpg">
            <p>茄子是通策集团唯一的移动管理平台和全员营销平台，服务对象包括To C的患者和To B医疗机构及其管理者和员工，聚焦于客户，实现客户资源共享、治疗透明，打通支付为医疗机构提供业务服务和用户管理服务</p>
          </div>
          </a>   
        </div>
        <div class="index-box-05-box-line2">
          <div class="index-box-05-box">           
              <div class="index-box-05-img3"><a href="http://www.ortholink.cn/" target="_blank"><img src="../assets/index-box-05-img3.jpg"></a></div>            
              <div class="index-box-05-img7"><a href="http://cloud.eyar.com/" target="_blank"><img src="../assets/index-box-05-img7.jpg"></a></div>  
          </div>
          <div class="index-box-05-box">          
              <div class="index-box-05-img4"><a href="http://www.ortholink.cn/" target="_blank"><img src="../assets/index-box-05-img4.jpg"></a></div>             
              <div class="index-box-05-img8"><a href="http://cloud.eyar.com/" target="_blank"><img src="../assets/index-box-05-img8.jpg"></a></div>  
          </div>
          <div class="index-box-05-box">    
              <div class="index-box-05-img5"><a href="http://www.hibeauty.com/front.php?r=index/index" target="_blank"><img src="../assets/index-box-05-img5.jpg"></a></div>            
              <div class="index-box-05-img9"><a href="http://www.31kouqiang.com/front.php?r=index/index" target="_blank"><img src="../assets/index-box-05-img9.jpg"></a></div>  
          </div>
          <div class="index-box-05-box">         
              <div class="index-box-05-img6"><a href="http://www.hibeauty.com/front.php?r=index/index" target="_blank"><img src="../assets/index-box-05-img6.jpg"></a></div>             
              <div class="index-box-05-img10"><a href="http://www.31kouqiang.com/front.php?r=index/index" target="_blank"><img src="../assets/index-box-05-img10.jpg"></a></div>  
          </div>
          <div class="index-box-05-box">         
              <div class="index-box-05-img11"><img src="../assets/index-box-05-img11.jpg"></div>          
          </div>          
        </div>

        <div class="clear"></div>
      </div>
    </div>      


    <div class="index-box-06">
      <div class="index-box-06-main">
        <div class="index-box-06-box">
          <div class="index-box-06-title"><i class="right"><img src="../assets/fastcolumn-title-arr.png"></i>
            <span><h1>通策资本</h1><h2>Management team</h2></span>     
          </div>
        </div>
        <div class="index-box-06-box">
          <div class="index-box-06-img1">
            <img src="../assets/index-box-06-img1.jpg">
          </div>
        </div>
        <div class="index-box-06-box">
          <div class="index-box-06-img2">
            <img src="../assets/index-box-06-img2.jpg">
          </div>
        </div>
        <div class="index-box-06-box">
          <div class="index-box-06-img3">
            <img src="../assets/index-box-06-img3.jpg">
          </div>
        </div>
        <div class="index-box-06-box">
          <div class="index-box-06-img4">
            <img src="../assets/index-box-06-img4.jpg">
          </div>
        </div>
        <div class="index-box-06-box-line2">          
          <div class="index-box-06-box">
            <div class="index-box-06-img5">
              <img src="../assets/index-box-06-img5.jpg"> 
            </div>
          </div>  
          <div class="index-box-06-box">
            <div class="index-box-06-img6">
              <img src="../assets/index-box-06-img6.jpg"> 
            </div>
          </div>          
        </div>

        <div class="clear"></div>
      </div>
    </div>  

    <div class="index-box-07">
      <div class="index-box-07-main">
        <div class="index-box-07-box">
          <a href="http://www.sevenvillas.cn/" target="_blank">
          <div class="index-box-07-title"><i class="right"><img src="../assets/fastcolumn-title-arr.png"></i>
            <span><h1>紫萱度假村 </h1><h2>Management team</h2></span>     
          </div>
          </a>
          <div class="index-box-07-img1">
            <a href="http://www.sevenvillas.cn/" target="_blank"><img src="../assets/index-box-07-img1.jpg"></a>            
          </div>
        </div>
        <div class="index-box-07-box">          
          <div class="index-box-07-img2">
            <img src="../assets/index-box-07-img2.jpg">
          </div>
        </div>
        <div class="index-box-07-box">          
          <div class="index-box-07-img7">
            <p>罗莱夏朵·杭州紫萱度假村坐落在西湖风景名胜区，方圆1.5平方公里杨公堤新景区“三台梦迹”景区的重要组成部分。度假村营业面积约4800平方米，由七栋中式风格的别墅，投资数亿极具明清江南古风，集雅致、奢华、古朴于一体，，圈筑一处西湖边的隐迹花园、婚礼圣地、艺术殿堂。</p>
          </div>
          <div>
            <div class="index-box-07-img8 left"><p>中餐</p></div>
            <div class="index-box-07-img3 left"><img src="../assets/index-box-07-img3.jpg"></div>
          </div>
        </div>
        <div class="index-box-07-box">          
          <div class="index-box-07-img9">
            <p>法餐</p>
          </div>
        </div>
        <div class="index-box-07-box">          
          <div class="index-box-07-img4">
            <img src="../assets/index-box-07-img4.jpg">
          </div>
        </div>
        <div class="index-box-07-box">          
          <div class="index-box-07-img10">
            <p>怀石料理</p>
          </div>
        </div>
        <div class="index-box-07-box">          
          <div class="index-box-07-img5">
            <img src="../assets/index-box-07-img5.jpg">
          </div>
        </div>
        <div class="index-box-07-box" style="padding-left:1px;padding-right:0;">          
          <div class="index-box-07-img6">
            <img src="../assets/index-box-07-img6.jpg">
          </div>
        </div>

        <div class="clear"></div>
      </div>
    </div>   -->
    </div>
    <FooterMain></FooterMain>
  </div>
</template>

<script>
import HeaderMain from "./header";
import FooterMain from "./footer";
export default {
  name: "index",
  components: {
    HeaderMain,
    FooterMain
  },
  data() {
    return {
      currentMenuType: "index" //当前页面
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Index.vue